import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAuthContext } from '../pages/SplashScreen/AuthContext';

export const ProtectedRoute = (props: RouteProps) => {

  const { user } = useAuthContext();

  if (user === null) {
    return <Redirect to="/login" />;
  }

  return <Route {...props} />;

};

